/* eslint-disable no-undef */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory(
            require('backbone'),
            require('../utils/fp_utils'),
        );
    } else if (typeof define === 'function' && define.amd) {
        define(['backbone', '../utils/fp_utils'], factory);
    }
})(this, function (Backbone, fpUtils) {
    'use strict';

    return Backbone.Model.extend({
        getFeatures: function () {
            return [
                // Width and height are sorted here because rotating
                // a mobile device swaps the values.
                fpUtils.pack('HHHHB', [
                    Math.max(screen.width, screen.height),
                    Math.min(screen.width, screen.height),
                    Math.max(screen.availWidth, screen.availHeight),
                    Math.min(screen.availWidth, screen.availHeight),
                    screen.colorDepth,
                ]),
            ];
        },
    });
});
